// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../bdap-area-delete-20261102/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg.feather{outline:none}", ""]);
// Exports
module.exports = exports;
